module.exports = __webpack_public_path__ + "static/media/webdesign-services-img37.5a4bd12f.jpg";